export default "__VITE_ASSET__8746cbce__"